<template>
  <div class="more" v-if="props.source.page != props.source.pageCount">
    <button
      v-if="!isLoadingShowMore"
      @click="showMore()"
      class="btn btn--white"
    >
      Показать еще
    </button>
    <div v-else class="btn btn--white">
      {{ !isLoadingShowMore ? "" : "...." }}
    </div>
  </div>

  <div class="pagination" ref="pagination">
    <div class="pagination__container">
      <div class="pagination__info">
        <RouterLink
          class="pagination__direction"
          :class="{ 'pagination__direction--disabled': !back || isLoadingShowMore}"
          :to="back || ''"
        >
          <svg width="8" height="12">
            <use xlink:href="@/assets/icons/sprite.svg#arrowLeft"></use>
          </svg>
        </RouterLink>
        <div v-for="(item, idx) in items" :key="idx" class="pagination__page">
          {{ item.label }}
        </div>
        <RouterLink
          class="pagination__direction pagination__direction--next"
          :class="{ 'pagination__direction--disabled': !next || isLoadingShowMore }"
          :to="next || ''"
        >
          <svg width="8" height="12">
            <use xlink:href="@/assets/icons/sprite.svg#arrowLeft"></use>
          </svg>
        </RouterLink>
      </div>
      <div class="pagination__text">из {{ source.pageCount }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { IPagination } from "@/models/models";
  import { computed, onMounted, PropType, ref, watch } from "vue";
  import { useRouter } from "vue-router";

  const props = defineProps({
    source: {
      type: Object as PropType<IPagination> | null,
      required: true,
    },
    moreCallback: {
      type: Promise,
    },
  });

  const emit = defineEmits(["showMore"]);

  let isLoadingShowMore = ref<boolean>(false as boolean);

  const items = computed(() => {
    let result = [];

    if (props.source.pageCount < 2) return [];

    let caseIt = false,
      changes = false;

    let pageCount = props.source.pageCount;
    let currentPage = props.source.page;
    let pageStart = currentPage - 2;
    let pageEnd = currentPage + 2;

    if (pageStart + 3 > pageCount) pageStart = pageCount - 3;

    if (pageStart < 1) pageStart = 1;

    // if (pageEnd <= 5) {
    //   pageEnd = 5;
    //   caseIt = true;
    // }
    if (pageCount == 6 || pageCount == 7) {
      changes = true;
      switch (currentPage) {
        case 1:
          pageStart = 1;
          pageEnd = 3;
          break;
        case 2:
          pageStart = 2;
          pageEnd = 4;
          break;
        case 3:
          pageStart = 2;
          pageEnd = 4;
          break;
        case 4:
          pageStart = 4;
          pageEnd = 4;
          break;
      }
    }
    // if (pageEnd >= pageCount) pageEnd = pageCount - 1;

    // if (pageStart > 1) {
    //   result.push({
    //     label: 1,
    //     route: getRoute(1),
    //   });
    // }

    // if (pageStart > 2) {
    //   result.push({
    //     label: "...",
    //     selected: false,
    //     route: getRoute(Math.round(pageStart / 2)),
    //   });
    // }

    do {
      if (currentPage == pageStart) {
        result.push({
          label: pageStart,
          selected: currentPage == pageStart,
          route: getRoute(pageStart),
        });
      }
      pageStart++;
    } while (pageStart <= pageEnd);

    let dot = Math.round(pageEnd + (pageCount - pageEnd) / 2);

    if (pageEnd < dot - 1) {
      // result.push({
      //   label: "...",
      //   selected: false,
      //   route: getRoute(dot),
      // });
    } else {
      if (caseIt == true) {
        result.push({
          label: pageStart,
          selected: currentPage == pageStart,
          route: getRoute(pageStart),
        });
      }
    }

    // result.push({
    //   label: pageCount,
    //   selected: currentPage == pageStart,
    //   route: getRoute(pageCount)
    // });

    return result;
  });

  const back = computed(() => {
    if (props.source.page > 1) {
      return getRoute(props.source.page - 1);
    }
    return null;
  });

  const next = computed(() => {
    if (props.source.page != props.source.pageCount) {
      return getRoute(props.source.page + 1);
    }
    return null;
  });

  function getRoute(page: number) {
    const router = useRouter();
    if(router) {
      return {
        path: router.currentRoute.value?.path,
        params: router.currentRoute.value.params,
        query: { ...router.currentRoute.value.query, ...{ page: page } },
      };
    }
  }

  function showMore() {
    isLoadingShowMore.value = true
    emit("showMore", props.source.page + 1);
  }

  watch(
    () => props.source,
    async (newVal, oldVal) => {
      isLoadingShowMore.value = false
    },
    {
      deep: true,
      immediate: false,
    }
  );

</script>
<style lang="scss">
  .more {
    background-color: $lightGreen;
    width: 100%;
    border-radius: 4px;
    margin-bottom: 16px;

    .btn {
      height: 48px;
    }
  }

  .pagination {
    &__container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
    }

    &__info {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }

    &__text {
      color: $darkGray;
      font-size: 12px;
      line-height: 120%;
      font-weight: 400;
    }

    &__page {
      padding: 14px 52px;
      background-color: $lightGray;
      color: $almostBlack;
      font-size: 18px;
      line-height: 20px;
      font-weight: 400;
      border-radius: 4px;
    }

    &__direction {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      background-color: $lightGreen;
      border-radius: 6px;

      &--next {
        transform: rotate(180deg);
      }

      &--disabled {
        cursor: none;
        pointer-events: none;
        opacity: 0.4;
      }
    }
  }
</style>
